// extracted by mini-css-extract-plugin
module.exports = {"pa_icon":"pa-icons_pa_icon__OQQ7u","check_icon":"pa-icons_check_icon__QQOQK","close_icon":"pa-icons_close_icon__qGSsk","thin_cross":"pa-icons_thin_cross__6t568"};